import { all, call } from 'redux-saga/effects';
import { sagas as reboot } from './power/rebootModule';
import { sagas as reset } from './power/resetModule';
import { sagas as resize } from './resizeModule';
import { sagas as resizeVolume } from './resizeVolumeModule';
import { sagas as availableFlavors } from './availableFlavorsModule';
import { sagas as availableStorage } from './availableStorageModule';
import { sagas as vncConsole } from './vncConsoleModule';
import { sagas as availableConfigs } from './availableConfigsModule';

export default function* serverSaga() {
	yield all([
		call(availableStorage),
		call(availableConfigs),
		call(availableFlavors),
		call(availableStorage),
		call(reboot),
		call(reset),
		call(resize),
		call(resizeVolume),
		call(vncConsole),
	]);
}
